import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  InputGroup,
  ProgressBar,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import CustomRadioButton from "../../../../../../../components/CustomRadioButton";
import Flatpickr from "react-flatpickr";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getCalendarSvg } from "../../../../../../../svgIcons/CalenderIcons";
import Select, { components } from "react-select";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  formatDate,
  parseFormattedDate,
} from "../../../../../../../helpers/dateFormatter";
import { getAgeCategoryNameById } from "../../../../../../../helpers/productCategoryObjectTransformation";
import {
  usePostPriceScheduleNonExclusiveMutation,
  useUpdateProductPriceScheduleMutation,
} from "../../../../../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../../../../../assets/delete-item-icon.svg";
import { v4 as uuidv4 } from "uuid"; // Import UUID
import { generateTimeOptions } from "../../../../../../../helpers/timeFormatter";
// import DeleteIcon from "../../../../../../assets/delete-item-icon.svg";

// Example time options
const timeOptions = generateTimeOptions();

const validationSchema = Yup.object().shape({
  startDate: Yup.date().required("Start date is required"),
  daysApply: Yup.array()
    .min(1, "Please select at least one day")
    .required("Please select at least one day"),
});

const ByPersonModalSection = ({
  setStep,
  setData,
  handleClose,
  weeklyData,
  ageGroupData,
  productDetail,
  productId,
  stepOneData,
  setStepOneData,
  productOptionId,
  scheduleData,
  schedule,
}) => {
  const navigate = useNavigate();
  const [updateProductPriceSchedule, { isLoading }] =
    useUpdateProductPriceScheduleMutation();
  const flatpickrRef = useRef();
  const flatpickrRef2 = useRef();
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  const [selectedDays, setSelectedDays] = useState(false);
  const [enableTieredPrice, setEnableTieredPrice] = useState(
    scheduleData ? Boolean(scheduleData?.is_tiered) : false
  );
  const [liveAvailability, setLiveAvailability] = useState(
    productDetail?.live_availability === 1 ? true : false
  );

  const [discount, setDiscount] = useState(
    productDetail?.product_options[0]?.product_price_schedules[0]
      ?.product_schedule_prices[0]?.discount_percent
      ? parseInt(
          productDetail?.product_options[0]?.product_price_schedules[0]
            ?.product_schedule_prices[0]?.discount_percent
        )
      : 12
  );
  console.log("====================================");
  console.log("discount", discount);
  console.log("====================================");
  // Age group management
  // State to store selected age groups and their prices
  const [selectedAgeGroups, setSelectedAgeGroups] = useState(() => {
    // Check if scheduleData and its relevant properties exist
    if (
      scheduleData?.is_tiered === 0 &&
      Array.isArray(scheduleData?.product_schedule_prices)
    ) {
      return scheduleData.product_schedule_prices.map((price) => ({
        price_age_category_id: price.price_category_id,
        retail_price: price.retail_price || "",
        discount_percent: discount,
        discount_price: parseFloat(
          (price.retail_price - (price.retail_price * discount) / 100).toFixed(
            2
          )
        ),
      }));
    }
    // Default to empty array if conditions are not met
    return [];
  });

  useEffect(() => {
    setSelectedAgeGroups(() => {
      // Check if scheduleData and its relevant properties exist
      if (
        scheduleData?.is_tiered === 0 &&
        Array.isArray(scheduleData?.product_schedule_prices)
      ) {
        return scheduleData.product_schedule_prices.map((price) => ({
          price_age_category_id: price.price_category_id,
          retail_price: price.retail_price || "",
          discount_percent: discount,
          discount_price: parseFloat(
            (
              price.retail_price -
              (price.retail_price * discount) / 100
            ).toFixed(2)
          ),
        }));
      }
      // Default to empty array if conditions are not met
      return [];
    });
  }, [discount]);

  const [tieredAgeGroups, setTieredAgeGroups] = useState(() => {
    // Check if scheduleData and its relevant properties exist
    if (
      scheduleData?.is_tiered === 1 &&
      Array.isArray(scheduleData?.product_schedule_prices)
    ) {
      return scheduleData.product_schedule_prices.map((price) => ({
        price_age_category_id: price.price_category_id,
        retail_price: price.retail_price || "",
      }));
    }
    // Default to empty array if conditions are not met
    return [];
  });

  // State to store errors
  const [error, setError] = useState("");
  // Handle checkbox change
  const handleCheckboxChange = (categoryId) => {
    setError("");
    let isSelected;
    if (enableTieredPrice) {
      isSelected = tieredAgeGroups.some(
        (item) => item.price_age_category_id === categoryId
      );
    } else {
      isSelected = selectedAgeGroups.some(
        (item) => item.price_age_category_id === categoryId
      );
    }

    if (isSelected) {
      if (enableTieredPrice) {
        setTieredAgeGroups((prev) =>
          prev.filter((item) => item.price_age_category_id !== categoryId)
        );
      } else {
        setSelectedAgeGroups((prev) =>
          prev.filter((item) => item.price_age_category_id !== categoryId)
        );
      }
    } else {
      if (enableTieredPrice) {
        setTieredAgeGroups((prev) => [
          ...prev,
          { price_age_category_id: categoryId, retail_price: "" },
        ]);
      } else {
        setSelectedAgeGroups((prev) => [
          ...prev,
          { price_age_category_id: categoryId, retail_price: "" },
        ]);
      }
    }
  };

  // Handle retail price change
  const handlePriceChange = (categoryId, value) => {
    setError("");

    setSelectedAgeGroups((prev) => {
      // Check if categoryId exists in the current selectedAgeGroups
      const categoryExists = prev.some(
        (item) => item.price_age_category_id === categoryId
      );

      // If it exists, update the value, otherwise add a new object
      if (categoryExists) {
        return prev.map((item) =>
          item.price_age_category_id === categoryId
            ? { ...item, retail_price: value }
            : item
        );
      } else {
        // Add new object if categoryId doesn't exist
        return [
          ...prev,
          { price_age_category_id: categoryId, retail_price: value },
        ];
      }
    });
  };

  // Handle min price change
  const handleMinPriceChange = (categoryId, value) => {
    setError("");
    setSelectedAgeGroups((prev) =>
      prev.map((item) =>
        item.price_age_category_id === categoryId
          ? { ...item, min_quantity: parseInt(value) }
          : item
      )
    );
  };

  // Handle max price change
  const handleMaxPriceChange = (categoryId, value) => {
    setError("");
    setSelectedAgeGroups((prev) =>
      prev.map((item) =>
        item.price_age_category_id === categoryId
          ? { ...item, max_quantity: parseInt(value) }
          : item
      )
    );
  };
  // Test
  // Initial state setup
  // State for input values
  const [rows, setRows] = useState(() => {
    let defaultRows = {};

    // Initialize rows based on ageGroupData
    if (ageGroupData?.data) {
      ageGroupData.data.forEach((category) => {
        if (category.age_group_id) {
          // Ensure the structure is present
          if (!defaultRows[category.age_group_id]) {
            defaultRows[category.age_group_id] = [
              { min_price: "", max_price: "", retail_price: "" },
            ];
          }
        }
      });
    }

    // If scheduleData is tiered, append the product_schedule_prices
    if (
      scheduleData?.is_tiered &&
      Array.isArray(scheduleData?.product_schedule_prices)
    ) {
      scheduleData.product_schedule_prices.forEach((price) => {
        const ageId = price.price_category_id;

        if (ageId) {
          // If no existing entry for the ageId, create one
          if (!defaultRows[ageId]) {
            defaultRows[ageId] = [];
          }

          // Check if there's an entry and if it contains values or is empty
          const lastEntry = defaultRows[ageId][defaultRows[ageId].length - 1];

          if (
            !lastEntry ||
            (lastEntry.min_price === "" &&
              lastEntry.max_price === "" &&
              lastEntry.retail_price === "")
          ) {
            // Replace only if the last entry is completely empty
            defaultRows[ageId] = [
              {
                min_price: price.min_quantity || "",
                max_price: price.max_quantity || "",
                retail_price: price.retail_price || "",
              },
            ];
          } else {
            // Append the new object if the existing one is non-empty
            defaultRows[ageId].push({
              min_price: price.min_quantity || "",
              max_price: price.max_quantity || "",
              retail_price: price.retail_price || "",
            });
          }
        }
      });
    }

    return defaultRows;
  });

  // State for final result
  const [finalResult, setFinalResult] = useState([]);

  // Update final result whenever rows change
  useEffect(() => {
    const updatedResult = Object.entries(rows).flatMap(([ageGroupId, fields]) =>
      fields.map(({ min_price, max_price, retail_price }) => ({
        price_age_category_id: ageGroupId,
        retail_price: parseFloat(retail_price) || 0,
        min_quantity: parseInt(min_price) || 0,
        max_quantity: parseInt(max_price) || 0,
      }))
    );
    setFinalResult(updatedResult);
  }, [rows]);

  // Handle adding a new set of fields
  const handleAddField = (ageGroupId) => {
    setRows((prevRows) => ({
      ...prevRows,
      [ageGroupId]: [
        ...prevRows[ageGroupId],
        { min_price: "", max_price: "", retail_price: "" },
      ],
    }));
  };

  // Handle change in min, max, retail price inputs
  const handleFieldChange = (ageGroupId, index, field, value) => {
    setError("");
    setRows((prevRows) => ({
      ...prevRows,
      [ageGroupId]: prevRows[ageGroupId].map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  // Handle removing a set of fields
  const handleRemoveField = (ageGroupId, index) => {
    setRows((prevRows) => ({
      ...prevRows,
      [ageGroupId]: prevRows[ageGroupId].filter((_, i) => i !== index),
    }));
  };

  // Values for days field
  const handleDayClick = (dayId, values, setFieldValue) => {
    const updatedDays = values?.daysApply?.includes(dayId)
      ? values.daysApply.filter((id) => id !== dayId)
      : [...values.daysApply, dayId];
    setFieldValue("daysApply", updatedDays);
    if (values?.daysApply?.includes(dayId)) {
      setSelectedDays(false);
    }
    if (updatedDays.length === 7) {
      setSelectedDays(true);
    }
  };

  const handleSelectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    setFieldValue("daysApply", allDayIds);
  };

  const handleDeselectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    if (allDayIds.every((dayId) => values.daysApply.includes(dayId))) {
      setFieldValue("daysApply", []);
    }
  };

  // Time slot selection

  // Function to convert the array
  const convertTimeSlots = (timeSlots) => {
    if (timeSlots.length === 0) {
      // Return a default object if the array is empty
      return [
        {
          id: uuidv4(),
          start_time: "",
          end_time: "",
        },
      ];
    }

    // Map each slot to the desired format
    return timeSlots.map((slot) => ({
      id: uuidv4(), // Generate a new UUID
      start_time: slot.product_start_time,
      end_time: slot.product_end_time,
    }));
  };

  const [timeSlots, setTimeSlots] = useState(
    scheduleData?.product_schedule_time_slots
      ? convertTimeSlots(scheduleData?.product_schedule_time_slots)
      : [{ id: uuidv4(), start_time: "", end_time: "" }]
  );

  const [timeError, setTimeError] = useState("");

  // Handle start time change
  const handleStartTimeChange = (id, selectedOption) => {
    const newTimeSlots = timeSlots.map((slot) =>
      slot.id === id ? { ...slot, start_time: selectedOption.value } : slot
    );
    setTimeSlots(newTimeSlots);
  };

  // Handle end time change
  const handleEndTimeChange = (id, selectedOption) => {
    setTimeError(""); // Clear any existing error
    const newTimeSlots = timeSlots.map((slot) =>
      slot.id === id ? { ...slot, end_time: selectedOption.value } : slot
    );
    setTimeSlots(newTimeSlots);
  };

  // Add new time slot
  const addTimeSlot = () => {
    setTimeSlots([
      ...timeSlots,
      { id: uuidv4(), start_time: "", end_time: "" },
    ]);
  };

  // Handle removing a time slot by id
  const handleRemoveTimeSlot = (idToRemove) => {
    const updatedTimeSlots = timeSlots.filter((slot) => slot.id !== idToRemove);
    setTimeSlots(updatedTimeSlots); // Update state after removal
  };

  // Validate time slots
  const validateTimeSlots = (values) => {
    let valid = true;
    setTimeError(""); // Clear previous errors

    let hasValidTimeRange = false;
    let hasStartTimeForFixedSlots = false;

    for (const [index, slot] of timeSlots.entries()) {
      // Check if there is a start time without a corresponding end time
      if (
        slot.start_time &&
        !slot.end_time &&
        values.timeApply === "TimeRange"
      ) {
        setTimeError(
          `Start time ${slot.start_time} at slot ${
            index + 1
          } does not have a corresponding end time.`
        );
        valid = false;
        break; // Exit early since validation failed
      }

      // Check if the end time is smaller than the start time
      if (
        slot.start_time &&
        slot.end_time &&
        slot.end_time <= slot.start_time &&
        values.timeApply === "TimeRange"
      ) {
        setTimeError(
          `End time ${slot.end_time} at slot ${
            index + 1
          } should be greater than start time ${slot.start_time}.`
        );
        valid = false;
        break; // Exit early since validation failed
      }

      // Check for at least one valid time range if timeApply is "TimeRange"
      if (
        values.timeApply === "TimeRange" &&
        slot.start_time &&
        slot.end_time
      ) {
        hasValidTimeRange = true;
      }

      // Check for at least one start time if timeApply is "FixedSlots"
      if (values.timeApply === "FixedSlots" && slot.start_time) {
        hasStartTimeForFixedSlots = true;
      }
    }

    // Check if at least one start and end time pair is selected when timeApply is "TimeRange"
    if (values.timeApply === "TimeRange" && !hasValidTimeRange) {
      setTimeError("At least one start and end time pair must be selected.");
      valid = false;
    }

    // Check if at least one start time is selected when timeApply is "FixedSlots"
    if (values.timeApply === "FixedSlots" && !hasStartTimeForFixedSlots) {
      setTimeError("At least one start time must be selected.");
      valid = false;
    }

    return valid;
  };

  // Filter options based on start time
  const getEndTimeOptions = (startTime) => {
    return timeOptions.filter((option) => option.value > startTime);
  };

  // Set all age groups with default retail_price when data is loaded
  useEffect(() => {
    // if (ageGroupData?.data?.length > 0) {
    //   const defaultAgeGroups = ageGroupData.data.map((category) => ({
    //     price_age_category_id: category.age_group_id,
    //     retail_price: "",
    //   }));
    //   console.log('=================defaultAgeGroups===================');
    //   console.log(ageGroupData.data,defaultAgeGroups);
    //   console.log('====================================');
    //   setSelectedAgeGroups(defaultAgeGroups);
    // }
  }, [ageGroupData]);

  return (
    <Formik
      initialValues={{
        startDate: scheduleData?.schedule_start_date
          ? new Date(parseFormattedDate(scheduleData?.schedule_start_date))
          : null,
        endDate: scheduleData?.schedule_end_date
          ? new Date(parseFormattedDate(scheduleData?.schedule_end_date))
          : null,
        daysApply: scheduleData?.product_schedule_days
          ? scheduleData?.product_schedule_days.map((item) => item.day_id)
          : [],
        timeApply:
          scheduleData?.product_schedule_time_slots.length > 0
            ? scheduleData?.product_schedule_time_slots[0].product_time_type
            : null,
        // tieredPricing: [],
      }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        // Function to clean up the array
        const finalAgeData = enableTieredPrice
          ? finalResult
              .filter((item) => item.retail_price !== 0) // Remove objects with retail_price 0
              .map((item) => ({
                ...item,
                price_age_category_id: parseInt(item.price_age_category_id), // Convert ID to integer
              }))
          : selectedAgeGroups;
        try {
          if (finalAgeData.length === 0) {
            setError("Please select at least one age group.");
            return;
          }

          for (const group of finalAgeData) {
            // Check if retail price is missing
            if (group.retail_price == null || group.retail_price < 0) {
              setError(
                `Age group ${getAgeCategoryNameById(
                  group.price_age_category_id,
                  ageGroupData?.data
                )} does not have a retail price.`
              );
              return;
            }

            // Check if min or max quantity is missing when tiered pricing is enabled
            if (enableTieredPrice) {
              if (!group.max_quantity || !group.min_quantity) {
                setError(
                  `Age group ${getAgeCategoryNameById(
                    group.price_age_category_id,
                    ageGroupData?.data
                  )} does not have either min or max quantity.`
                );
                return;
              }

              // Check if min quantity is greater than max quantity
              if (group.min_quantity > group.max_quantity) {
                setError(
                  `Age group ${getAgeCategoryNameById(
                    group.price_age_category_id,
                    ageGroupData?.data
                  )} has a min quantity greater than max quantity.`
                );
                return;
              }

              // Check if max quantity is smaller than min quantity
              if (group.max_quantity === 0 || group.min_quantity === 0) {
                setError(
                  `Age group ${getAgeCategoryNameById(
                    group.price_age_category_id,
                    ageGroupData?.data
                  )} has either min or max quantity of 0.`
                );
                return;
              }
            }
          }
          // Additional validation only when tiered pricing is enabled
          if (enableTieredPrice) {
            const ageGroupMap = {};

            // Group the entries by `price_age_category_id`
            for (const group of finalAgeData) {
              const categoryId = group.price_age_category_id;

              if (!ageGroupMap[categoryId]) {
                ageGroupMap[categoryId] = [];
              }

              // Push the min and max quantities to the group
              ageGroupMap[categoryId].push({
                min_quantity: group.min_quantity,
                max_quantity: group.max_quantity,
              });
            }

            // Now validate for overlapping ranges
            for (const [categoryId, ranges] of Object.entries(ageGroupMap)) {
              ranges.sort((a, b) => a.min_quantity - b.min_quantity); // Sort ranges by min_quantity
              for (let i = 0; i < ranges.length - 1; i++) {
                const currentRange = ranges[i];
                const nextRange = ranges[i + 1];

                // Check if the current range overlaps with the next one
                if (currentRange.max_quantity >= nextRange.min_quantity) {
                  setError(
                    `Age group ${getAgeCategoryNameById(
                      parseInt(categoryId),
                      ageGroupData?.data
                    )} has overlapping or conflicting quantity ranges: [${
                      currentRange.min_quantity
                    }-${currentRange.max_quantity}] conflicts with [${
                      nextRange.min_quantity
                    }-${nextRange.max_quantity}].`
                  );
                  return;
                }
              }
            }
          }

          // Additional validation only when tiered pricing is enabled
          if (enableTieredPrice) {
            const ageGroupMap = {};

            // Group the entries by `price_age_category_id`
            for (const group of finalAgeData) {
              const categoryId = group.price_age_category_id;
              if (!ageGroupMap[categoryId]) {
                ageGroupMap[categoryId] = [];
              }

              // Push the min and max quantities to the group
              ageGroupMap[categoryId].push({
                min_quantity: group.min_quantity,
                max_quantity: group.max_quantity,
              });
            }

            // Now validate for overlapping ranges
            for (const [categoryId, ranges] of Object.entries(ageGroupMap)) {
              ranges.sort((a, b) => a.min_quantity - b.min_quantity); // Sort ranges by min_quantity
              for (let i = 0; i < ranges.length - 1; i++) {
                const currentRange = ranges[i];
                const nextRange = ranges[i + 1];

                // Check if the current range overlaps with the next one
                if (currentRange.max_quantity >= nextRange.min_quantity) {
                  setError(
                    `Age group ${getAgeCategoryNameById(
                      parseInt(categoryId),
                      ageGroupData?.data
                    )} has overlapping or conflicting quantity ranges: [${
                      currentRange.min_quantity
                    }-${currentRange.max_quantity}] conflicts with [${
                      nextRange.min_quantity
                    }-${nextRange.max_quantity}].`
                  );
                  return;
                }
              }
            }
          }

          const validDay = validateTimeSlots(values);
          if (validDay) {
            const endTimes = timeSlots
              .map((slot) => slot.end_time)
              .filter((time) => time !== "");
            let data = {
              product_id: schedule?.product_id,
              product_option_id: scheduleData?.product_option_id,
              option_title: schedule?.product_option_title,
              option_schedule_id: scheduleData?.id,
              product_price_unit: schedule?.product_option_type,
              max_capacity_per_booking: parseInt(
                schedule?.product_option_max_capacity_per_booking
              ),
              start_date: formatDate(values.startDate),
              end_date: values.endDate ? formatDate(values.endDate) : null,
              schedules_days: values.daysApply,
              time_type:
                values.timeApply === "NoTimeSlot" ? null : values.timeApply,
              price_age_categories: finalAgeData,
              is_tiered: enableTieredPrice ? 1 : 0,
              live_availability: liveAvailability ? 1 : 0,
            };
            if (values.timeApply === "TimeRange") {
              data = {
                ...data,
                start_time: timeSlots
                  .map((slot) => slot.start_time)
                  .filter((time) => time !== ""),
                end_time: endTimes.length === 0 ? null : endTimes,
              };
            }
            if (values.timeApply === "FixedSlots") {
              data = {
                ...data,
                start_time: timeSlots
                  .map((slot) => slot.start_time)
                  .filter((time) => time !== ""),
              };
            }

            if (productOptionId) {
              data = { ...data, product_option_id: productOptionId };
            }
            const lang = localStorage.getItem("productLanguage")
              ? localStorage.getItem("productLanguage")
              : "en";
            const response = await updateProductPriceSchedule({
              ...data,
              lang: lang,
            });

            if (response?.data?.status) {
              toast.success(response?.data?.message, {
                position: "top-center",
                autoClose: 3000,
              });

              handleClose();
              // setStepOneData(null);
            }
            if (response?.error) {
              const errors = response?.error?.data?.errors;
              if (response?.error?.status === 401) {
                localStorage.removeItem("DODLoginToken");
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
                navigate("/login");
              } else if (errors) {
                for (const field in errors) {
                  if (errors.hasOwnProperty(field)) {
                    // const combinedErrors = errors[field].join(" ");
                    // if (field === "supplier_type") {
                    //   setFieldError("option", combinedErrors);
                    // }
                  }
                }
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              } else {
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              }
            }
          }
        } catch (error) {}
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <>
          <div className="cs-ps-modal-header">
            <div className="row">
              <div className="col-md-9">
                <p className="cp-ps-form-heading">Schedule and prices</p>
                <p className="cp-ps-note">
                  Here are the detail of price option, this can be managed later
                  anytime from product management
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <Form onSubmit={handleSubmit}>
              <div className="col-md-9">
                <Row className="cp-ps-date-select-section mb-3">
                  <Col md={6}>
                    <Form.Group controlId="startDate">
                      <Form.Label className="cp-ps-form-label">
                        Start date
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="startDate"
                          placeholder="Set Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date(),
                            // maxDate: values.endDate,
                          }}
                          ref={flatpickrRef}
                          value={values.startDate}
                          onChange={([date]) => {
                            setFieldValue(
                              "startDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                        <ErrorMessage
                          name="startDate"
                          component="div"
                          className="text-danger"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="endDate">
                      <Form.Label className="cp-ps-form-label">
                        End date <span>(optional)</span>
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="endDate"
                          placeholder="End Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            minDate: values.startDate, // Set minDate to the selected start date
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date()
                          }}
                          ref={flatpickrRef2}
                          value={values.endDate}
                          onChange={([date]) => {
                            setFieldValue(
                              "endDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef2.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group
                  controlId="tieredPricing"
                  className="cp-ps-time-switch-container"
                >
                  <FormCheck
                    type="switch"
                    id="enable-tiered-pricing"
                    label="Live availability"
                    checked={liveAvailability}
                    onChange={() => {
                      setLiveAvailability(!liveAvailability);
                    }}
                  />
                </Form.Group>
                {liveAvailability && (
                  <>
                    <Form.Group controlId="">
                      <Form.Label className="cp-ps-form-label">
                        Select the days these prices apply
                      </Form.Label>
                      <div
                        style={{ cursor: "pointer", width: "fit-content" }}
                        onClick={(e) => {
                          if (e.target.tagName !== "INPUT") {
                            setSelectedDays(!selectedDays);
                            if (!selectedDays) {
                              handleSelectAllDays(values, setFieldValue);
                            } else {
                              handleDeselectAllDays(values, setFieldValue);
                            }
                          }
                        }}
                        className="cp-pc-attraction-modal-input-checkbox d-flex align-items-center cp-ps-radio-input border-0 h-0 "
                      >
                        <Form.Check
                          type="checkbox"
                          name={"options"}
                          // value={value}
                          checked={selectedDays}
                          onChange={() => {
                            setSelectedDays(!selectedDays);
                            if (!selectedDays) {
                              handleSelectAllDays(values, setFieldValue);
                            } else {
                              handleDeselectAllDays(values, setFieldValue);
                            }
                            // setFieldValue("daysApply", selectedDays);
                          }}
                          className={"radio-button mt-0 mb-0 cp-ps-radio"}
                        />
                        <p className=" m-0 p-0 ">Select All</p>
                      </div>

                      <div className="d-flex flex-column cp-ps-step-2-days-checkboxes-wrapper">
                        <div className="cp-ps-step-2-days-checkboxes">
                          {weeklyData?.data?.map((day) => (
                            <div
                              key={day.day_id}
                              name
                              className={`cp-ps-day-check-box ${
                                values?.daysApply?.includes(day?.day_id)
                                  ? "cp-ps-day-selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleDayClick(
                                  day.day_id,
                                  values,
                                  setFieldValue
                                )
                              }
                            >
                              {day?.day_name}
                            </div>
                          ))}
                        </div>
                        <ErrorMessage
                          name="daysApply"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="timeApply">
                      <Form.Label className="cp-ps-form-label">
                        Select the time these prices apply{" "}
                        <span>(optional)</span>
                      </Form.Label>
                      <div className="d-flex cp-ps-apply-time-wrapper">
                        <CustomRadioButton
                          label="Fixed time slot"
                          isSelected={values.timeApply === "FixedSlots"}
                          onClick={() => {
                            setFieldValue("timeApply", "FixedSlots");
                            setTimeSlots([
                              { id: uuidv4(), start_time: "", end_time: "" },
                            ]);
                            setTimeError("");
                          }}
                        />
                        <CustomRadioButton
                          label="Time range"
                          isSelected={values.timeApply === "TimeRange"}
                          onClick={() => {
                            setFieldValue("timeApply", "TimeRange");
                            setTimeSlots([
                              { id: uuidv4(), start_time: "", end_time: "" },
                            ]);
                            setTimeError("");
                          }}
                        />
                        <CustomRadioButton
                          label="No time slot"
                          isSelected={values.timeApply === "NoTimeSlot"}
                          onClick={() => {
                            setFieldValue("timeApply", "NoTimeSlot");
                            setTimeSlots([]);
                            setTimeError("");
                          }}
                        />
                      </div>

                      {values.timeApply === "TimeRange" &&
                        timeSlots.map((slot, index) => {
                          // Get all end_times from previous slots
                          const previousEndTimes = timeSlots
                            .slice(0, index) // Only consider previous slots
                            .map((s) => s.end_time)
                            .filter((endTime) => endTime); // Filter out any undefined or null end_times

                          // Find the latest end_time from previous slots
                          const latestEndTime = previousEndTimes.length
                            ? Math.max(
                                ...previousEndTimes.map((time) =>
                                  new Date(`1970-01-01T${time}:00`).getTime()
                                )
                              )
                            : null;

                          // Get the index of the latest end_time in the timeOptions array
                          const latestEndTimeIndex = latestEndTime
                            ? timeOptions.findIndex(
                                (option) =>
                                  new Date(
                                    `1970-01-01T${option.value}:00`
                                  ).getTime() === latestEndTime
                              )
                            : -1;

                          // Filter the available time options for the current slot's start time
                          const availableStartTimeOptions =
                            latestEndTimeIndex >= 0
                              ? timeOptions.slice(latestEndTimeIndex + 1) // Exclude all options before and including latestEndTime
                              : timeOptions; // If no end_time exists, return all options

                          return (
                            <InputGroup
                              className="cp-ps-timeslot-main mb-3 d-flex align-items-center"
                              key={slot.id}
                            >
                              {/* Start Time Select */}
                              <span className="me-2 from-to-span">From</span>

                              <Select
                                name={`startTime-${slot.id}`}
                                options={availableStartTimeOptions} // Use the filtered start time options
                                placeholder="Select start time"
                                className="p-0 form-control cp-ps-timeslot-select ms-0"
                                value={availableStartTimeOptions.find(
                                  (option) => option.value === slot.start_time
                                )}
                                onChange={(selectedOption) =>
                                  handleStartTimeChange(slot.id, selectedOption)
                                }
                                components={{
                                  Control: ({ children, ...props }) => (
                                    <components.Control {...props}>
                                      {children}
                                      <div className="select-icon">
                                        <Icon icon="ic:baseline-keyboard-arrow-down" />
                                      </div>
                                    </components.Control>
                                  ),
                                }}
                              />

                              {/* End Time Select */}
                              <div className="d-flex align-items-center ms-2">
                                <span className="from-to-span">to</span>
                                <Select
                                  name={`endTime-${slot.id}`}
                                  options={getEndTimeOptions(slot.start_time)}
                                  isDisabled={!slot.start_time}
                                  placeholder="Select end time"
                                  className="p-0 form-control cp-ps-timeslot-select"
                                  value={timeOptions.find(
                                    (option) => option.value === slot.end_time
                                  )}
                                  onChange={(selectedOption) =>
                                    handleEndTimeChange(slot.id, selectedOption)
                                  }
                                  components={{
                                    Control: ({ children, ...props }) => (
                                      <components.Control {...props}>
                                        {children}
                                        <div className="select-icon">
                                          <Icon icon="ic:baseline-keyboard-arrow-down" />
                                        </div>
                                      </components.Control>
                                    ),
                                  }}
                                />
                              </div>

                              {/* Delete Icon */}
                              <img
                                src={DeleteIcon}
                                alt="delete-icon"
                                className="ms-2"
                                onClick={() => handleRemoveTimeSlot(slot.id)} // Use id to remove the correct slot
                                style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
                              />
                            </InputGroup>
                          );
                        })}

                      {values.timeApply === "FixedSlots" &&
                        timeSlots.map((slot, index) => {
                          // Get selected start times from all slots except the current one
                          const selectedTimes = timeSlots
                            .filter((s) => s.id !== slot.id)
                            .map((s) => s.start_time);

                          // Filter the available time options for the current slot
                          const availableTimeOptions = timeOptions.filter(
                            (option) => !selectedTimes.includes(option.value)
                          );

                          return (
                            <InputGroup
                              className="cp-ps-timeslot-main mb-3 d-flex align-items-center"
                              key={slot.id}
                            >
                              {/* Start Time Select */}
                              <Select
                                name={`startTime-${slot.id}`}
                                options={availableTimeOptions}
                                placeholder="Select start time"
                                className="p-0 form-control cp-ps-timeslot-select ms-0"
                                value={availableTimeOptions.find(
                                  (option) => option.value === slot.start_time
                                )}
                                onChange={(selectedOption) =>
                                  handleStartTimeChange(slot.id, selectedOption)
                                }
                                components={{
                                  Control: ({ children, ...props }) => (
                                    <components.Control {...props}>
                                      {children}
                                      <div className="select-icon">
                                        <Icon icon="ic:baseline-keyboard-arrow-down" />
                                      </div>
                                    </components.Control>
                                  ),
                                }}
                              />

                              {/* Delete Icon */}
                              <img
                                src={DeleteIcon}
                                alt="delete-icon"
                                className="ms-2"
                                onClick={() => handleRemoveTimeSlot(slot.id)} // Use id to remove the correct slot
                                style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
                              />
                            </InputGroup>
                          );
                        })}
                      {timeError && (
                        <div className="text-danger mb-2">{timeError}</div>
                      )}
                      {(values.timeApply === "TimeRange" ||
                        values.timeApply === "FixedSlots") && (
                        <p onClick={addTimeSlot} className="add-time-slot">
                          + Add a time slot
                        </p>
                      )}
                    </Form.Group>{" "}
                  </>
                )}

                {/* <Form.Group
                  controlId="tieredPricing"
                  className="cp-ps-time-switch-container"
                >
                  <FormCheck
                    type="switch"
                    id="enable-tiered-pricing"
                    label="Enable tiered pricing"
                    checked={enableTieredPrice}
                    onChange={() => {
                      setEnableTieredPrice(!enableTieredPrice);
                      //   setSelectedAgeGroups([]); //
                      //   setRows(
                      //     ageGroupData?.data?.reduce((acc, category) => {
                      //       acc[category.age_group_id] = [
                      //         { min_price: "", max_price: "", retail_price: "" },
                      //       ];
                      //       return acc;
                      //     }, {}) || {}
                      //   );
                    }}
                  />
                </Form.Group>*/}
              </div>
              <div className="discount-container text-center">
                <h5 className="text-success mb-3">Recommended Discount</h5>
                <div className="slider-wrapper">
                  <span className="slider-label">10%</span>
                  <input
                    type="range"
                    className="form-range custom-slider"
                    min="10"
                    max="90"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                  />
                  <span className="slider-label">90%</span>
                </div>
                <p className="mt-2 selected-discount">
                  Selected Discount: {discount}%
                </p>
              </div>

              <div className="col-md-12">
                {!enableTieredPrice ? (
                  <div className="cp-ps-step-2-tiered-pricing-table">
                    <Row className="cp-ps-step-2-table-header">
                      <Col md={2}></Col>
                      <Col md={3}>Suggested retail price</Col>
                      <Col md={2}>Discounted price</Col>
                      <Col md={3}>Amount you will get paid</Col>
                      <Col md={2}>Commission rate</Col>
                    </Row>
                    {ageGroupData?.data?.map((category) => (
                      <Row key={category} className="cp-ps-step-2-table-row">
                        <Col md={2} className="d-flex align-items-center">
                          <div className="mb-0 cp-pc-attraction-modal-input-checkbox d-flex align-items-center cp-ps-radio-input border-0 h-0">
                            {/* <Form.Check
                              type="checkbox"
                              name={"options"}
                              // value={value}
                              checked={selectedAgeGroups.some(
                                (item) =>
                                  item.price_age_category_id ===
                                  category.age_group_id
                              )}
                              onChange={() =>
                                handleCheckboxChange(category.age_group_id)
                              }
                              className={"radio-button mt-0 mb-0 cp-ps-radio"}
                            /> */}
                            <p className=" m-0 p-0 ">
                              {category?.price_category_name}
                            </p>
                          </div>
                        </Col>
                        <Col md={3} className="d-flex align-items-center">
                          <InputGroup>
                            <InputGroup.Text>AED</InputGroup.Text>
                            <Form.Control
                              type="number"
                              placeholder="00"
                              min={0}
                              value={
                                selectedAgeGroups.find(
                                  (item) =>
                                    item.price_age_category_id ===
                                    category.age_group_id
                                )?.retail_price || ""
                              }
                              onKeyDown={(e) => {
                                if (
                                  e.key === "-" ||
                                  e.key === "+" ||
                                  e.key === "e"
                                ) {
                                  e.preventDefault(); // Prevent negative, plus, or exponential notation input
                                }
                              }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value >= 0 || value === "") {
                                  handlePriceChange(
                                    category.age_group_id,
                                    value
                                  );
                                }
                              }}
                              // disabled={
                              //   !selectedAgeGroups.some(
                              //     (item) =>
                              //       item.price_age_category_id ===
                              //       category.age_group_id
                              //   )
                              // }
                            />
                          </InputGroup>
                        </Col>
                        <Col md={2} className="d-flex align-items-center">
                          <InputGroup>
                            <Form.Control
                              type="number"
                              placeholder="00"
                              min={0}
                              value={
                                selectedAgeGroups.find(
                                  (item) =>
                                    item.price_age_category_id ===
                                    category.age_group_id
                                )?.retail_price
                                  ? (
                                      selectedAgeGroups.find(
                                        (item) =>
                                          item.price_age_category_id ===
                                          category.age_group_id
                                      )?.retail_price -
                                      (selectedAgeGroups.find(
                                        (item) =>
                                          item.price_age_category_id ===
                                          category.age_group_id
                                      )?.retail_price *
                                        discount) /
                                        100
                                    ).toFixed(2)
                                  : ""
                              }
                              disabled={true}
                            />
                          </InputGroup>
                        </Col>
                        <Col md={3} className="d-flex align-items-center">
                          <InputGroup>
                            <InputGroup.Text>AED</InputGroup.Text>
                            <Form.Control
                              type="number"
                              placeholder="00"
                              min={0}
                              value={
                                selectedAgeGroups.find(
                                  (item) =>
                                    item.price_age_category_id ===
                                    category.age_group_id
                                )?.retail_price
                                  ? (
                                      (
                                        selectedAgeGroups.find(
                                          (item) =>
                                            item.price_age_category_id ===
                                            category.age_group_id
                                        )?.retail_price -
                                        (selectedAgeGroups.find(
                                          (item) =>
                                            item.price_age_category_id ===
                                            category.age_group_id
                                        )?.retail_price *
                                          discount) /
                                          100
                                      ).toFixed(2) -
                                      (
                                        (
                                          selectedAgeGroups.find(
                                            (item) =>
                                              item.price_age_category_id ===
                                              category.age_group_id
                                          )?.retail_price -
                                          (selectedAgeGroups.find(
                                            (item) =>
                                              item.price_age_category_id ===
                                              category.age_group_id
                                          )?.retail_price *
                                            discount) /
                                            100
                                        ).toFixed(2) *
                                        (parseFloat(
                                          productDetail?.product_categories[0]
                                            ?.category_commission
                                            ?.default_commission
                                        ) /
                                          100)
                                      ).toFixed(2)
                                    ).toFixed(2)
                                  : ""
                              }
                              disabled={true}
                            />
                          </InputGroup>
                        </Col>
                        <Col md={2} className="d-flex align-items-center">
                          <Form.Control
                            type="number"
                            placeholder="00"
                            className="cp-ps-settwo-com-input"
                            value={
                              selectedAgeGroups.find(
                                (item) =>
                                  item.price_age_category_id ===
                                  category.age_group_id
                              )?.retail_price
                                ? (
                                    (
                                      selectedAgeGroups.find(
                                        (item) =>
                                          item.price_age_category_id ===
                                          category.age_group_id
                                      )?.retail_price -
                                      (selectedAgeGroups.find(
                                        (item) =>
                                          item.price_age_category_id ===
                                          category.age_group_id
                                      )?.retail_price *
                                        discount) /
                                        100
                                    ).toFixed(2) *
                                    (parseFloat(
                                      productDetail?.product_categories[0]
                                        ?.category_commission
                                        ?.default_commission
                                    ) /
                                      100)
                                  ).toFixed(2)
                                : ""
                            }
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    ))}
                    {error && <div className="text-danger mt-2">{error}</div>}
                  </div>
                ) : (
                  <div className="cp-ps-step-2-tiered-pricing-table cp-ps-step-2-tiered-pricing-table-two pt-0">
                    <Table className="mt-4 ">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Min - Max per Booking</th>
                          <th>Suggested Retail Price</th>
                          <th>Discounted Price</th>
                          <th>Amount You Will Get Paid</th>
                          <th>Commission Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ageGroupData?.data?.map((category) => (
                          <tr key={category.age_group_id}>
                            {/* First column: Checkbox and price category name */}
                            <td className="">
                              <div className="mb-0 age-radio-btn cp-pc-attraction-modal-input-checkbox d-flex align-items-center cp-ps-radio-input border-0 h-0">
                                {/* <Form.Check
                                  type="checkbox"
                                  name={"options"}
                                  checked={tieredAgeGroups?.some(
                                    (item) =>
                                      item.price_age_category_id ===
                                      category.age_group_id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(category.age_group_id)
                                  }
                                  className={
                                    "radio-button mt-0 mb-0 cp-ps-radio"
                                  }
                                /> */}
                                <p className="m-0 p-0">
                                  {category?.price_category_name}
                                </p>
                              </div>
                            </td>

                            {/* Second column: Min - Max price inputs */}
                            <td className="">
                              {rows[category.age_group_id]?.map(
                                (row, index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center my-1"
                                  >
                                    <Form.Control
                                      type="number"
                                      placeholder="Min"
                                      min={0}
                                      max={999}
                                      value={row.min_price}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e"].includes(e.key))
                                          e.preventDefault();
                                      }}
                                      onChange={(e) =>
                                        handleFieldChange(
                                          category.age_group_id,
                                          index,
                                          "min_price",
                                          e.target.value
                                        )
                                      }
                                      // disabled={
                                      //   !tieredAgeGroups.some(
                                      //     (item) =>
                                      //       item.price_age_category_id ===
                                      //       category.age_group_id
                                      //   )
                                      // }
                                      className={`cp-pc-age-group-input ob-pi-input me-1`}
                                    />
                                    -
                                    <Form.Control
                                      type="number"
                                      placeholder="Max"
                                      min={0}
                                      max={999}
                                      value={row.max_price}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e"].includes(e.key))
                                          e.preventDefault();
                                      }}
                                      onChange={(e) =>
                                        handleFieldChange(
                                          category.age_group_id,
                                          index,
                                          "max_price",
                                          e.target.value
                                        )
                                      }
                                      // disabled={
                                      //   !tieredAgeGroups.some(
                                      //     (item) =>
                                      //       item.price_age_category_id ===
                                      //       category.age_group_id
                                      //   )
                                      // }
                                      className={`cp-pc-age-group-input ob-pi-input me-1`}
                                    />
                                  </div>
                                )
                              )}
                            </td>

                            {/* Third column: Retail price */}
                            <td>
                              {rows[category.age_group_id]?.map(
                                (row, index) => (
                                  <div
                                    key={index}
                                    className="my-1 age-info-group"
                                  >
                                    <InputGroup>
                                      <InputGroup.Text>AED</InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        placeholder="00"
                                        value={row.retail_price}
                                        onKeyDown={(e) => {
                                          if (["-", "+", "e"].includes(e.key))
                                            e.preventDefault();
                                        }}
                                        onChange={(e) =>
                                          handleFieldChange(
                                            category.age_group_id,
                                            index,
                                            "retail_price",
                                            e.target.value
                                          )
                                        }
                                        // disabled={
                                        //   !tieredAgeGroups.some(
                                        //     (item) =>
                                        //       item.price_age_category_id ===
                                        //       category.age_group_id
                                        //   )
                                        // }
                                      />
                                    </InputGroup>
                                  </div>
                                )
                              )}
                            </td>

                            {/* Fourth column: dicounted price */}
                            <td>
                              {rows[category.age_group_id]?.map(
                                (row, index) => (
                                  <div
                                    key={index}
                                    className=" my-1 age-info-group"
                                  >
                                    <InputGroup>
                                      <InputGroup.Text>AED</InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        placeholder="00"
                                        value={
                                          row.retailPrice
                                            ? (
                                                row.retailPrice -
                                                (row.retailPrice * discount) /
                                                  100
                                              ).toFixed(2)
                                            : ""
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </div>
                                )
                              )}
                            </td>

                            {/* Fourth column: Amount you will get paid */}
                            <td>
                              {rows[category.age_group_id]?.map(
                                (row, index) => (
                                  <div
                                    key={index}
                                    className=" my-1 age-info-group"
                                  >
                                    <InputGroup>
                                      <InputGroup.Text>AED</InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        placeholder="00"
                                        value={
                                          row.retail_price
                                            ? (row.retail_price * 0.99).toFixed(
                                                2
                                              )
                                            : ""
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </div>
                                )
                              )}
                            </td>

                            {/* Fifth column: Commission rate + Add/Remove buttons */}
                            <td className="">
                              {rows[category.age_group_id]?.map(
                                (row, index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center mt-1"
                                  >
                                    <Form.Control
                                      type="number"
                                      placeholder="00"
                                      value={
                                        row.retail_price
                                          ? (
                                              row.retail_price -
                                              row.retail_price * 0.99
                                            ).toFixed(2)
                                          : ""
                                      }
                                      disabled
                                      className="cp-ps-settwo-com-input me-2"
                                    />
                                    {/* Add/Remove buttons */}
                                    <div className="d-flex flex-column ms-1">
                                      {/* Show the Add button only for the first commission field */}
                                      {index === 0 && (
                                        <button
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleAddField(
                                              category.age_group_id
                                            );
                                          }}
                                          className="add-more-age-group-btn"
                                        >
                                          +
                                        </button>
                                      )}
                                      {/* Show the Remove button only for additional fields (index > 0) */}
                                      {rows[category.age_group_id]?.length >
                                        1 &&
                                        index > 0 && (
                                          <img
                                            src={DeleteIcon}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleRemoveField(
                                                category.age_group_id,
                                                index
                                              );
                                            }}
                                            className="remove-age-group"
                                            alt="del"
                                          >
                                            {/* x */}
                                          </img>
                                        )}
                                    </div>
                                  </div>
                                )
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {error && <div className="text-danger mt-2">{error}</div>}
                  </div>
                )}

                <div
                  className={`w-100 d-flex align-items-center justify-content-end`}
                >
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isLoading}
                    // onClick={() => {
                    //   setData((prevData) => [...prevData, 1]);
                    //   handleClose();
                    // }}
                  >
                    Save {isLoading && <Spinner size="sm" />}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </>
      )}
    </Formik>
  );
};

export default ByPersonModalSection;
